<div slot="fixed" class="footer-wrap" *ngIf="!saveButton">
    <div *ngIf="forAdmin && userService.userInfo" class="toggle content-wrap">
        <div [routerLink]="['/home']" routerDirection="back" class="item"
             [ngClass]="{active: currentPage === 'home', 'primary-bg-color':currentPage === 'home'}">
            <div class="item-content">
                <img src="assets/img/footer/home-white.svg" alt="user" class="home"
                     [ngClass]="{hidden: currentPage !== 'home'}">
                <app-inline-svg class="home" [file]="'assets/img/footer/home-blue.svg'"
                                [ngClass]="{hidden: currentPage === 'home'}"></app-inline-svg>
                <div class="text">{{"__HOME_MY_HOME__" | translate}}</div>
            </div>
        </div>
        <div class="blue-round-message" [routerLink]="['/coach/requests-incoming']"
             [ngClass]="{'visible' : currentPage == 'home'}" *ngIf="userService.userInfo.company.enabled_coaching && progress !== null && progress.coach_requests.incompleted > 0">
            {{ progress.coach_requests.incompleted }}
        </div>
        <div [routerLink]="['/team']" routerDirection="forward" class="item"
             [ngClass]="{active: currentPage !== 'home', 'primary-bg-color':currentPage !== 'home'}">
            <div class="item-content">
                <img src="assets/img/footer/my-team-white.svg" alt="users" class="my-team"
                     [ngClass]="{hidden: currentPage === 'home'}">
                <app-inline-svg class="my-team" [file]="'assets/img/footer/my-team-blue.svg'"
                     [ngClass]="{hidden: currentPage !== 'home'}"></app-inline-svg>
                <div class="text my-team-text-long">{{"__HOME_MY_TEAM_WHOLE__" | translate}}</div>
                <div class="text my-team-text-short">{{"__HOME_MY_TEAM__" | translate}}</div>
            </div>
        </div>
    </div>
    <div class="list-wrap" *ngIf="userService.userInfo && isMenuDisplayed">
        <div class="list content-wrap">
            <div (click)="navigateTo('/tasks')" class="item" *ngIf="level === 'learner'">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/group.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/group-mobile.svg'"></app-inline-svg>
                    <div *ngIf="progress !== null && progress.tasks.incompleted > 0"
                         class="number primary-bg-color">{{progress.tasks.incompleted}}</div>
                </div>
                <div class="text">{{"__FOOTER_TASK__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/e-learning')" class="item" *ngIf="level === 'learner' && userService.userInfo.company.enabled_elearning && userService.userInfo.company.id !== 189">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/monitor.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/monitor-mobile.svg'"></app-inline-svg>
                    <div *ngIf="progress !== null && progress.elearning.incompleted > 0"
                         class="number primary-bg-color">{{progress.elearning.incompleted}}</div>
                </div>
                <div class="text">{{"__FOOTER_ELEARNING__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/resources')" class="item" *ngIf="level === 'learner'">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/box.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/box-mobile.svg'"></app-inline-svg>
                    <div *ngIf="progress !== null && progress.resources.incompleted > 0"
                         class="number primary-bg-color">{{progress.resources.incompleted}}</div>
                </div>
                <div class="text">{{"__FOOTER_RESOURCES__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/coach/journey')" class="item" *ngIf="level === 'learner' && userService.userInfo.is_coaching">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/coaching-journeys.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/coaching-journeys-mobile.svg'"></app-inline-svg>
                </div>
                <div class="text">{{"__FOOTER_COACHING_JOURNEY__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/skills-checker')" class="item" *ngIf="level === 'learner' && userService.userInfo.company.enabled_sk">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/list.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/list-mobile.svg'"></app-inline-svg>
                    <div *ngIf="progress !== null && progress.skillschecker.incompleted > 0"
                         class="number primary-bg-color">{{progress.skillschecker.incompleted}}</div>
                </div>
                <div class="text">{{"__FOOTER_SC__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/coaching/my/comments')" class="item" *ngIf="level === 'learner' && (userService.userInfo.company.enabled_cr || userService.userInfo.company.enabled_cr_self)">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/users1.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/users-mobile.svg'"></app-inline-svg>
                    <div *ngIf="progress !== null && progress.coaching.incompleted > 0"
                         class="number primary-bg-color">{{progress.coaching.incompleted}}</div>
                </div>
                <div class="text">{{"__FOOTER_COACHING__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/review')" class="item" *ngIf="level === 'learner' && userService.userInfo.company.enabled_review">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/group.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/group-mobile.svg'"></app-inline-svg>
                </div>
                <div class="text">{{"PDR Reports" | translate}}</div>
            </div>

            <div (click)="navigateTo('/team')" class="item" *ngIf="level === 'manager'">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/group.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/group-mobile.svg'"></app-inline-svg>
                    <div *ngIf="progress !== null && progress.tasks_direct.incompleted > 0"
                         class="number primary-bg-color">{{progress.tasks_direct.incompleted}}</div>
                </div>
                <div class="text desktop">{{"__FOOTER_TEAM_TASK__" | translate}}</div>
                <div class="text mobile">{{"__FOOTER_TEAM_TASK_MOBILE__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/skills-checker/team')" class="item" *ngIf="level === 'manager' && userService.userInfo.company.enabled_sk">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/list.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/list-mobile.svg'"></app-inline-svg>
                    <div *ngIf="false" class="number primary-bg-color"></div>
                </div>
                <div class="text desktop">{{"__FOOTER_TEAM_SC__" | translate}}</div>
                <div class="text mobile">{{"__FOOTER_TEAM_SC_MOBILE__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/coaching/team')" class="item" *ngIf="level === 'manager' && userService.userInfo.company.enabled_cr">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/footer/users1.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/footer/users-mobile.svg'"></app-inline-svg>
                    <div *ngIf="false" class="number primary-bg-color"></div>
                </div>
                <div class="text desktop">{{"__FOOTER_TEAM_COACHING__" | translate}}</div>
                <div class="text mobile">{{"__FOOTER_TEAM_COACHING_MOBILE__" | translate}}</div>
            </div>
            <div (click)="navigateTo('coach/availability')" class="item" *ngIf="level === 'manager' && userService.userInfo.company.enabled_coaching">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/coach-calendar-main.svg'"></app-inline-svg>
                    <app-inline-svg class="mobile-only" [file]="'assets/img/coach-calendar-main-white.svg'"></app-inline-svg>
                    <div *ngIf="false" class="number primary-bg-color"></div>
                </div>
                <div class="text desktop">{{"__FOOTER_COACHING_AVALIABILITY__" | translate}}</div>
                <div class="text mobile">{{"__FOOTER_COACHING_AVALIABILITY_MOBILE__" | translate}}</div>
            </div>
            <div (click)="navigateTo('/coach/requests-incoming')" class="item" *ngIf="level === 'manager' && userService.userInfo.company.enabled_coaching">
                <div class="icon">
                    <app-inline-svg class="desktop-only" [file]="'assets/img/appoint-round.svg'"></app-inline-svg>
                    <div *ngIf="progress !== null && progress.coach_requests.incompleted > 0" class="number request">
                        {{progress.coach_requests.incompleted}}</div>
                </div>
                <div class="text desktop">{{"__FOOTER_APPOINT_REQUESTS__" | translate}}</div>
                <div class="text mobile">{{"__FOOTER_APPOINT_REQUESTS_MOBILE__" | translate}}</div>
            </div>
        </div>
    </div>
</div>

<div slot="fixed" class="footer-wrap back-save primary-bg-color" *ngIf="backButton || saveButton">
    <div class="elements content-wrap-inner" [ngClass]="{'justify-content-center': !backButton && saveButton}">
        <div class="back" *ngIf="false"></div>
        <div class="back" (click)="goBack()" *ngIf="backButton">
            <img src="assets/img/footer/back.svg" alt="back" class="touch-eff">
            {{"__FOOTER_BACK__" | translate}}
        </div>
        <div class="save" *ngIf="!saveButton"></div>
        <div class="save" (click)="onSave()" *ngIf="saveButton">
            <ng-container *ngIf="!isSaving">
                {{"__FOOTER_SAVE__" | translate}}
                <img src="assets/img/footer/save.svg" alt="save" class="touch-eff">
            </ng-container>
            <ion-spinner *ngIf="isSaving"></ion-spinner>
        </div>
    </div>
</div>
